const { formatReasonLabel } = require("./controlPreview");

function resolveReasonKey(selectedReason, defaultSelection) {
  if (Array.isArray(selectedReason) && selectedReason.length > 0) {
    return selectedReason[0];
  }
  return defaultSelection || "";
}

function buildSelectedReasonLabel({
  selectedReason = [],
  defaultSelection = "",
  parseKey = (value) => value || "",
  controlPreview = null,
  fallbackLabel = "없음",
} = {}) {
  const reasonKey = resolveReasonKey(selectedReason, defaultSelection);
  const baseLabel = parseKey(reasonKey);
  return formatReasonLabel(baseLabel, controlPreview, fallbackLabel);
}

/**
 * 신고 사유 key별 도메인 매핑.
 * 백엔드 services/report/constants.py::ReasonKeyChoices 기준.
 * 새 key 추가 시 이 맵도 함께 업데이트 필요.
 */
const CALL_REASON_KEYS = new Set([
  "NO_ANSWER",
  "SCAM_TALK",
  "AGGRESSIVE_TONE",
  "RUDE_TALK",
  "MULTI_PEOPLE",
  "PERSONAL_LIFE",
  "ASK_CONTACT",
  "SEXUAL_TALK",
  "VIOLENT_TALK",
  "HATE_TALK",
  "BODY_RUDE_TALK",
  "DISRESPECT_TALK",
]);

// MINOR는 통화·피드·프로필 3벌 공통 사유라 도메인 딱지를 붙이지 않는다.
const PROFILE_REASON_KEYS = new Set([
  "FAKE_PROFILE",
  "BAD_NICKNAME",
  "BAD_PROFILE",
  "BIO_CONTACT",
]);

/**
 * 신고 사유 key로 도메인 라벨을 반환한다.
 * @param {string} key - 신고 사유 key (e.g. "FEED_CONTACT", "SCAM_TALK", "BAD_NICKNAME")
 * @returns {string} 도메인 라벨 ("통화", "피드", "프로필", "")
 */
function getDomainLabel(key) {
  if (!key || typeof key !== "string") return "";
  const upper = key.toUpperCase();
  if (upper.startsWith("FEED_")) return "피드";
  if (CALL_REASON_KEYS.has(upper)) return "통화";
  if (PROFILE_REASON_KEYS.has(upper)) return "프로필";
  return "";
}

/** 도메인 라벨의 정렬 우선순위를 반환한다. */
function getDomainSortOrder(key) {
  const label = getDomainLabel(key);
  switch (label) {
    case "통화":
      return 0;
    case "피드":
      return 1;
    case "프로필":
      return 2;
    default:
      return 3;
  }
}

module.exports = {
  buildSelectedReasonLabel,
  getDomainLabel,
  getDomainSortOrder,
};
